import * as React from 'react';
import {Input} from "../../../inputs/Input";
import {useEffect, useRef, useState} from "react";
import {getHostApi, getRequestConfig, request} from "../../../../utils";
import {getUserId} from "../../MonCompteAction";

export interface cmjnData {
  cyan: number | null | undefined,
  hexadecimal: string | null | undefined,
  jaune: number | null | undefined,
  magenta: number | null | undefined,
  noir: number | null | undefined,
  isPersonnalise: boolean | undefined
}

interface UpdateCmjnProps {
  data: cmjnData
  onUpdateCmjn?: (idCaddies: string, cmjnData: cmjnData) => void
  idCaddies: string;
  isDT: boolean;
  isDeplie: boolean;
}

export const UpdateCmjn = (props: UpdateCmjnProps) => {

  const arrayCmjn = [{"libelle": "C", "state": "cyan"}, {"libelle": "M", "state": "magenta"}, {"libelle": "J", "state": "jaune"}, {"libelle": "N", "state": "noir"}];
  const data = {cyan: props.data?.cyan, magenta: props.data?.magenta, jaune: props.data?.jaune, noir: props.data?.noir, hexadecimal: props.data?.hexadecimal, isPersonnalise: props.data?.isPersonnalise};
  const {cyan,magenta,jaune,noir,hexadecimal,isPersonnalise} = data;
  const [cmjn, setValue] = useState<cmjnData>({cyan, magenta, jaune, noir, hexadecimal, isPersonnalise});
  const [isDeplie, enableDeplie] = useState<boolean>(false);
  const [hexa, setHexadecimal] = useState<string | undefined | null>(hexadecimal);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if(props.data?.cyan !== cmjn['cyan'] && (cmjn['cyan'] === undefined || cmjn['cyan'] === null)) {
      setHexadecimal(hexadecimal);
      setValue({cyan, magenta, jaune, noir, hexadecimal, isPersonnalise});
    }
  }, [props.data]);

  useEffect(() => {
    enableDeplie(props.isDeplie)
  }, [props.isDeplie])

  function handleChangeInput(event: string, name: string) {
    if(name === "cyan" || name === "magenta" || name === "jaune" || name === "noir") {
      let value = parseInt(event,10);
      if(value < 0 || isNaN(value)) { value = 0; }
      if(value > 100) { value = 100; }
      cmjn[name] = value;
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(()=> {
        fetchHexa(cmjn['cyan'], cmjn['magenta'], cmjn['jaune'], cmjn['noir']);
      },1000);
    }
  }

  function fetchValue(index: string) : number | null | undefined  {
    if(index === "cyan" || index === "magenta" || index === "jaune" || index === "noir") {
      return cmjn[index];
    }
  }

  function handleResetCmjn() {
    setValue({cyan: null, magenta: null, jaune: null, noir: null, isPersonnalise: false, hexadecimal: null});
    if(props.onUpdateCmjn) {
      props.onUpdateCmjn(props.idCaddies, {cyan: null, magenta: null, jaune: null, noir: null, isPersonnalise: false, hexadecimal: null});
    }
  }

  function handleModifyCmjn() {
    if(props.onUpdateCmjn) {
      props.onUpdateCmjn(props.idCaddies, cmjn);
    }
  }

  function fetchHexa(cyan: number | null | undefined, magenta: number | null | undefined, jaune: number | null | undefined, noir: number | null | undefined) {
    let url = `${getHostApi()}/customers/${getUserId()}`;
    url = `${url}/hexa?cyan=${cyan}&magenta=${magenta}&jaune=${jaune}&noir=${noir}`;
    request("GET", url, {
      ...getRequestConfig()
    }).then((res) => {
      setHexadecimal(res.data.hexadecimal);
    }).catch((error) => {
      console.log(error);
    });
  }

  const preTitle = isPersonnalise ? `Couleur personnalisee` : `Couleur du textile`;
  const title = `${preTitle}\nC: ${cmjn['cyan']} M: ${cmjn['magenta']} J: ${cmjn['jaune']} N: ${cmjn['noir']}`;

  return (
      <div className={isDeplie ? '' : 'display-none'}>
        <div className={`my-2 text-center  justify-content-center align-items-center d-flex`} >
          {
            arrayCmjn.map((elt:{"libelle": string, "state": string}, key ) => {
              const index = elt.state;
              const value = fetchValue(index);
              return (
                  <div className={"d-flex"} key={key}>
                    <span className={"w-25"}>{elt.libelle}</span>
                    <Input className={`border-dark w-50`} type={"number"} min={0} max={100} value={value} name={index}
                           onChange={(event) => {
                             handleChangeInput(event, elt.state)
                           }}
                    /> %
                  </div>
              );
            })
          }
        </div>
        <div className={'mt-1 d-flex justify-content-between'}>
          {isPersonnalise && !props.isDT && <button onClick={handleResetCmjn}>Revenir à la couleur du textile initiale</button>}
          <button onClick={handleModifyCmjn} className={'ml-auto'}>
            <span className="d-flex align-items-center">
              <span className={"pl-3 pr-3"} title={title}
                    style={{border: "1px solid black", width: 20, backgroundColor: `#${hexa}`}}>&nbsp;</span>
              <span className="my-2 pl-2">Modifier</span>
            </span>
          </button>
        </div>
      </div>
  );
}